import { useEmitter } from './useEmitter'

export const useNotify =
  () =>
  (
    text: string,
    mode: 'error' | 'success' | 'info' | 'warning',
    options: {
      onClose?: () => void
      context?: 'root' | 'settings'
    } = {}
  ): void => {
    const { context = 'root', ...restOptions } = options

    switch (context) {
      case 'settings': {
        // translate notify API mode to OwnToast API mode
        // note: this may eventually be an update on the useNotify api itself
        // but for now, we can decouple the statuses
        let toastMode
        switch (mode) {
          case 'error':
            toastMode = 'danger'
            break
          case 'info':
            toastMode = 'neutral'
            break
          case 'success':
            toastMode = 'success'
            break
          case 'warning':
            toastMode = 'warning'
            break
          default:
            mode satisfies never
        }
        useEmitter.emit('settings-notification', {
          mode: toastMode,
          text,
          ...restOptions,
        })
        break
      }
      case 'root': {
        useEmitter.emit('root-notification', {
          mode,
          text,
          ...restOptions,
        })
        break
      }
      default:
        context satisfies never
    }
  }
